let sessionCode = null;

function getSessionCode() {
  if (!sessionCode) {
    sessionCode = crypto.randomUUID();
    // if (window.crypto && window.crypto.randomUUID) {
    //   sessionCode = window.crypto.randomUUID();
    // } else {
    //   // Fallback for browsers without randomUUID
    //   sessionCode = 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function(c) {
    //     const r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
    //     return v.toString(16);
    //   });
    // }
  }
  return sessionCode;
}

export default getSessionCode;